import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

import { NgCommService } from '../../ajs-ng-communication.service';

const FORBIDDEN = 403;

/**
 * Business error codes carried by a 403 payload, as defined by
 * `com.adb.dc.common.enums.ErrorCodeEnum` on the back-end side.
 */
const enum ForbiddenErrorCode {
	/** PROJECT_INVALID - project is inactive or expired. */
	ProjectInvalid = '61',
	/** PROJECT_VERSION_UNAVAILABLE - the requested project version is not available. */
	ProjectVersionUnavailable = '62',
}

@Injectable()
export class DcForbiddenInterceptor implements HttpInterceptor {
	public constructor(private readonly ngCommService: NgCommService) {}

	public intercept(
		req: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		return next.handle(req).pipe(
			catchError((responseErr: HttpErrorResponse) => {
				if (responseErr.status === FORBIDDEN) {
					void this.ngCommService.notifyOnError(
						this.getErrorMessage(responseErr.error?.code)
					);
				}
				return throwError(() => responseErr);
			})
		);
	}

	private getErrorMessage(code: string | undefined): string {
		switch (code) {
			case ForbiddenErrorCode.ProjectInvalid:
				return $localize`:i18n=@@general.errors.forbidden.projectInvalid:`;
			case ForbiddenErrorCode.ProjectVersionUnavailable:
				return $localize`:i18n=@@general.errors.forbidden.projectVersionUnavailable:`;
			default:
				return $localize`:i18n=@@general.errors.forbidden.cannotAccessElement:`;
		}
	}
}
